export default __webpack_public_path__ + "static/bg-cta--left-6da96cfd7a91d63abed478cb13872a9d.svg";